import { Datagrid, EditButton, List, ShowButton, TextField } from "react-admin";

import { rowStyles } from "../../utils/rowStyles";
import { ListPagination } from "../../utils/components/ListPagination";

import { ListActions } from "../../common/ListActions";

export function HomeList(): JSX.Element {
    return (
        <>
            <List pagination={<ListPagination />} perPage={20} filters={[]} actions={<ListActions />}>
                <Datagrid rowStyle={rowStyles}>
                    <TextField source="title" />
                    <TextField source="ageRange" />
                    <EditButton />
                    <ShowButton />
                </Datagrid>
            </List>
        </>
    );
}
